import { useContext, useMemo } from 'react'
import DialogContext, { IDialogContext } from '@providers/Dialog'

export default function useDialog() {
  const DialogValues = useContext<IDialogContext>(DialogContext)

  return DialogValues
}
